<template>
   <v-autocomplete
      v-model="localValue"
      :items="items"
      :loading="loading"

      :color="color"
      hide-no-data
      hide-selected
      :label="`${required ? '* ' + label : label}`"
      :placeholder="placeholder"
      return-object
      :required="required"
      :clearable="clearable"
      :class="isCenter ? 'custom centered-input' : 'custom'"
      :hint="hint"
      :disabled="disabled"
      @change="method"
   ></v-autocomplete>
</template>

<script>
//Mixins
import vmodel from '../js/mixins/vmodel'

export default {
   mixins: [vmodel],
   props: {
      method: {
         type: Function,
         default: () => {
            return
         }
      },
      clearable: { type: Boolean },
      placeholder: { type: String },
      loading: { type: Boolean },
      required: { type: Boolean },
      isCenter: { type: Boolean },
      hint: { type: String },
      color: { type: String },
      disabled: { type: Boolean }
   }
}
</script>

<style scoped>
.centered-input >>> input {
   text-align: center;
}
.custom >>> input {
   font-size: 1.2em;
}
.custom >>> label {
   font-size: 1.2em;
}
</style>
